export default class EnteredUserSerializer {
  static serialize(data) {
    return {
      name: data.name
    };
  }

  static deSerialize(data) {
    return {
      name: data.name
    };
  }
}